import styles from '../styles/app.module.css';
import { TEXT } from '../texts';

/** Stands in for an area that is sketched in the navigation but not built yet. */
export function Placeholder(): React.JSX.Element {
  return (
    <main className={styles.placeholder}>
      <p>{TEXT.inProgress}</p>
    </main>
  );
}
